/**
 * @param {object} content The page "content" object.
 * @param {object} data A dictionary of key/value pairs to inject into the content fields.
 * @returns object
 */
export function expandPageContent(content, data) {
  // This iterates over the page content object and looks
  // for fields with string values.  For each found string,
  // it does a regex replace that looks for "{{SOME_KEY}}",
  // and replaces it with the value of the corresponding
  // key (e.g. "SOME_KEY") in the data object.
  return Object.keys(content).reduce((acc, key) => {
    if (typeof content[key] === 'string') {
      acc[key] = content[key].replace(/{{([A-Z_]+)}}/g, match => {
        return data[match.slice(2,-2)] || match
      })
    } else {
      acc[key] = content[key]
    }
    return acc
  }, {})
}
